module.exports = __webpack_public_path__ + "img/0Q3A5108-23_FoamcoreMatted.c5cd0999.jpg";